import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { faqClearGuard, faqExistsGuard } from '@app/modules/faq/guards';
import { FAQDetailComponent } from '@app/modules/faq/pages/detail/faq-detail.component';
import { FAQOverviewComponent } from '@app/modules/faq/pages/overview/faq-overview.component';

const routes: Routes = [
    { path: '', redirectTo: 'overzicht', pathMatch: 'full' },
    { path: 'overzicht', component: FAQOverviewComponent },
    { path: 'toevoegen', component: FAQDetailComponent, canActivate: [ faqClearGuard ] },
    { path: 'bewerken/:id', component: FAQDetailComponent, canActivate: [ faqExistsGuard ] },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class FAQRoutingModule { }
